module.exports = __webpack_public_path__ + "fonts/MuseoSansCyrl-900.6c77bfcd.woff2";